app.service('wcAuthorizationView',function(){
	function init(){

	}
	return {
		init:init
	};
});
